function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1149 7.45704C15.0615 6.47232 13.6559 5.93587 12.2015 5.95791C9.54006 5.95791 7.27973 7.7179 6.4738 10.0878C6.04648 11.3297 6.04648 12.6746 6.4738 13.9165H6.47754C7.28721 16.2828 9.54379 18.0428 12.2052 18.0428C13.579 18.0428 14.7585 17.6983 15.6726 17.0899V17.0875C16.7484 16.3893 17.4831 15.2907 17.7117 14.0488H12.2015V10.1981H21.8238C21.9438 10.8668 22 11.5503 22 12.23C22 15.2714 20.8911 17.8428 18.9617 19.5844L18.9637 19.586C17.2731 21.1145 14.9528 22 12.2015 22C8.34428 22 4.81697 19.8689 3.08517 16.4922C1.63827 13.6667 1.63828 10.3377 3.08518 7.51218C4.81698 4.1318 8.34428 2.00067 12.2015 2.00067C14.7354 1.97128 17.1832 2.90456 19.0274 4.60209L16.1149 7.45704Z",
  fill: "#487C71"
});

function SvgGoogleNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleNegative);
export default __webpack_public_path__ + "static/media/google-negative.fe0fd17a.svg";
export { ForwardRef as ReactComponent };